export default (_, { market, t }) => {
  return {
    title: t('meta', 'articles.title'),
    description: undefined,
    canonical: `${market.domain}${
      (market.routes &&
        market.routes.editorialContentListing &&
        market.routes.editorialContentListing.path) ||
      '/articles'
    }`,
    openGraph: [],
    structuredData: undefined,
    hrefLang: undefined,
  };
};
